import { render, staticRenderFns } from "./CreatePickUp.vue?vue&type=template&id=be8ce42e&scoped=true"
import script from "./CreatePickUp.vue?vue&type=script&lang=js"
export * from "./CreatePickUp.vue?vue&type=script&lang=js"
import style0 from "./CreatePickUp.vue?vue&type=style&index=0&id=be8ce42e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8ce42e",
  null
  
)

export default component.exports